import {
  // Configure,
  HierarchicalMenu,
  RangeInput,
  RefinementList,
  SearchBox,
} from "react-instantsearch";
import { BaseFacet, Filter, binnenBuitenSort } from "../ca/filter/Facet";
import { config } from "../ca/state/config";

const Filters = () => (
  <>
    <div className="border-1 border-gray p-2">
      <SearchBox placeholder="Zoek op adres / kadastraal nummer" />
    </div>
    <div className="border-1 border-gray p-2">
      <p>Provincie/gemeente</p>
      <HierarchicalMenu attributes={["zone_1", "zone_2"]} limit={50} sortBy={["name"]} />
    </div>
    <div className="border-1 border-gray p-2">
      <p>Oppervlakte bebouwd</p>
      <RangeInput attribute="building_area" />
    </div>
    {["land_cover", "built_up_area", "urban_area", "arch_monuments", "nnn", "natura_2000"].map(
      (attr, i) => (
        <Filter key={attr} label={config.facetMapping[attr]}>
          <RefinementList attribute={attr} sortBy={i && i < 3 ? binnenBuitenSort : undefined} />
        </Filter>
      )
    )}
  </>
);

export const KaFacet = () => {
  // const [tab, setTab] = useState<Tab>("filters");
  return (
    <BaseFacet className="">
      {/*<Configure filters="zone_1:Groningen OR zone_1:Drenthe" />*/}
      {/*<TabBar active={tab} onChange={setTab} />*/}
      {/*<div className={tab === "filters" ? "" : "hidden"}>*/}
      <Filters />
      {/*</div>*/}
      {/*<div className={tab === "chat" ? "flex flex-col flex-1 min-h-0" : "hidden"}>*/}
      {/*  <KavelChat />*/}
      {/*</div>*/}
    </BaseFacet>
  );
};
